import React from 'react'
import WarningIcon from '../../../../../../../Assets/Images/icons/warning'

// Style constants
const COLORS = {
  warning: '#FFA000',
  white: '#FFF',
}

const TYPOGRAPHY = {
  fontFamily: 'Proxima Nova',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '24px',
}

// Component styles
const styles = {
  container: {
    position: 'absolute',
    top: '50px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    maxWidth: '500px',
    minWidth: '320px',
    height: '60px',
    backgroundColor: COLORS.warning,
    borderRadius: '8px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  messageSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  message: {
    color: COLORS.white,
    ...TYPOGRAPHY,
    margin: 0,
  },
  closeButton: {
    color: COLORS.white,
    ...TYPOGRAPHY,
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '4px 8px',
    borderRadius: '4px',
    transition: 'opacity 0.2s ease',
  },
}

export const UnsavedChangesWarn = ({ onCancel }) => {
  const handleCloseClick = () => {
    if (onCancel) {
      onCancel()
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleCloseClick()
    }
  }

  return (
    <div style={styles.container} role="alert" aria-live="polite">
      <div style={styles.content}>
        <div style={styles.messageSection}>
          <WarningIcon aria-hidden="true" />
          <span style={styles.message}>You have unsaved changes</span>
        </div>

        <button
          style={styles.closeButton}
          onClick={handleCloseClick}
          onKeyDown={handleKeyDown}
          aria-label="Close warning and discard changes"
          onMouseEnter={e => (e.target.style.opacity = '0.8')}
          onMouseLeave={e => (e.target.style.opacity = '1')}
        >
          Close anyway
        </button>
      </div>
    </div>
  )
}
